// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__rK00P","control":"Checkout_control__2Y4ii","actions":"Checkout_actions__1yeip","submit":"Checkout_submit__1Jwyr","invalid":"Checkout_invalid__17Ww7"};